import styled from 'styled-components';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledDS = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header--engineInfo {
        font-size: ${rem(14)};
        color: ${({ theme }) => theme.colors.black};
    }

    .stockModelCard-header--demoInfo {
        color: ${({ theme }) => theme.colors.grey29};
        font-size: ${({ theme }) => theme.fontSizes.h6};
    }

    .stockModelCard-header--heading {
        font-size: ${rem(32)};

        &.withDemoLabel {
            max-width: unset;
            margin-top: ${rem(20)};
        }
    }
`;
